const ALLOWED_DOMAINS = process.env.REACT_APP_ALLOWED_DOMAINS.split('|');

export default ALLOWED_DOMAINS;
